import React from 'react'

const HeroSection = () => {
    return (
        <div className="md:pt-40 pb-20" style={{ background: 'linear-gradient(297.01deg, #2196F3 -116.99%, #000000 100%)' }}>
            {/* Features Grid */}
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col w-full lg:flex-row lg:items-stretch">

                    <div className='md:hidden'>
                        <img src="/assets/feature-banner-mobile.jpg" alt="Feature Banner" />
                    </div>

                    <div className="container -mt-12 md:hidden px-6 mb-10 py-8 bg-[#001322] mx-auto max-w-xs">
                        <h2 className="text-3xl md:text-6xl font-bold text-primary mb-2">Features</h2>
                        <p className="md:text-2xl text-white max-w-2xl text-sm">
                            We leverage the latest technologies to build powerful, user friendly apps.
                        </p>
                    </div>

                    <div className="lg:w-2/3 order-2 lg:order-1 px-6">
                        {/* Features Heading */}
                        <div className="container my-8 hidden md:block">
                            <h2 className="text-3xl md:text-6xl font-bold text-white mb-2">Features</h2>
                            <p className="md:text-2xl text-white max-w-2xl">
                                We leverage the latest technologies to build powerful, user friendly apps.
                            </p>
                        </div>

                        <div className="flex w-full flex-col">
                            <div className='flex gap-6 lg:gap-0 w-full justify-between'>
                                <div className="w-full sm:w-1/2 pr-0 sm:pr-5 mb-10">
                                    {/* AI & Automation */}
                                    <div className="w-full">
                                        <div className="flex mb-3">
                                            <div className="rounded-full flex items-center w-12 h-12 md:h-16 md:w-16">
                                                <img
                                                    src="/assets/feature-4.png"
                                                    alt="AI & Automation"
                                                    className="h-full w-full object-cover"
                                                />
                                            </div>
                                        </div>
                                        <h3 className="font-bold text-white mb-2 text-sm md:text-2xl">AI & Automation</h3>
                                        <p className="text-white text-sm md:text-base">
                                            From ChatGPT integration to custom<br />
                                            AI workflows
                                        </p>
                                    </div>
                                </div>

                                <div className="w-full sm:w-1/2 pl-0 sm:pl-5 mb-10">
                                    {/* Native Development */}
                                    <div className="w-full">
                                        <div className="flex mb-3">
                                            <div className="rounded-full flex items-center w-12 h-12 md:h-16 md:w-16">
                                                <img
                                                    src="/assets/feature-1.png"
                                                    alt="Native Development"
                                                    className="h-full w-full object-cover"
                                                />
                                            </div>
                                        </div>
                                        <h3 className="font-bold text-white mb-2 text-sm md:text-2xl">Native Development</h3>
                                        <p className="text-white text-sm md:text-base">
                                            Specialist Apple and Android<br />
                                            developers for high performance
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-6 lg:gap-0 w-full justify-between">
                                <div className="w-full sm:w-1/2 pr-0 sm:pr-5 mb-10">
                                    {/* Payments */}
                                    <div className="w-full">
                                        <div className="flex mb-3">
                                            <div className="rounded-full flex items-center w-12 h-12 md:h-16 md:w-16">
                                                <img
                                                    src="/assets/feature-2.png"
                                                    alt="Payments"
                                                    className="h-full w-full object-cover"
                                                />
                                            </div>
                                        </div>
                                        <h3 className="font-bold text-white mb-2 text-sm md:text-2xl">Payments</h3>
                                        <p className="text-white text-sm md:text-base">
                                            Seamless transactions with Stripe,<br />
                                            PayPal, CCBIL and more
                                        </p>
                                    </div>
                                </div>

                                <div className="w-full sm:w-1/2 pl-0 sm:pl-5 mb-10">
                                    {/* Real-Time Features */}
                                    <div className="w-full">
                                        <div className="flex mb-3">
                                            <div className="rounded-full flex items-center w-12 h-12 md:h-16 md:w-16">
                                                <img
                                                    src="/assets/feature-3.png"
                                                    alt="Real-Time Features"
                                                    className="h-full w-full object-cover"
                                                />
                                            </div>
                                        </div>
                                        <h3 className="font-bold text-white mb-2 text-sm md:text-2xl">Real-Time Features</h3>
                                        <p className="text-white text-sm md:text-base">
                                            Live chat, live streams, notifications<br />
                                            and more
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="md:w-1/3 w-2/3 md:flex justify-center items-center mt-8 md:mt-0 order-1 lg:order-2 mx-auto hidden px-6">
                        <img
                            src="/assets/feature-banner.png"
                            alt="Feature Banner"
                            className="w-full max-w-md rounded-lg object-cover shadow-lg"
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default HeroSection
